<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <a-card class="m-wrong">
      <m-anim
        :options="notfound"
        class="anim"
        :height="getScreen ? 200 : 500"
        :width="getScreen ? 200 : 500"
      ></m-anim>
      <h1 class="margin-remove">404</h1>
      <h3 class="margin-bottom">Error Connection, please contact your administrator</h3>
      <a-button type="primary" block>
        <router-link :to="{path: '/'}">
          <a-icon type="rollback" />&nbsp; Back To Home
        </router-link>
      </a-button>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
export default {
  name: "E404",
  components: { "m-anim": lottie },
  data() {
    return {
      notfound: { animationData: notfound, loop: true }
    };
  },
  computed: {
    ...mapGetters(["getScreen"])
  },
  beforeRouteEnter(to, from, next) {
    next();
  }
};
</script>

<style>
</style>